import { render, staticRenderFns } from "./addLive.vue?vue&type=template&id=7fc1ffb0&scoped=true"
import script from "./addLive.vue?vue&type=script&lang=js"
export * from "./addLive.vue?vue&type=script&lang=js"
import style0 from "./addLive.vue?vue&type=style&index=0&id=7fc1ffb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc1ffb0",
  null
  
)

export default component.exports